import { render, staticRenderFns } from "./right_fun.vue?vue&type=template&id=7039f55c&scoped=true"
import script from "./right_fun.vue?vue&type=script&lang=js"
export * from "./right_fun.vue?vue&type=script&lang=js"
import style0 from "./right_fun.vue?vue&type=style&index=0&id=7039f55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7039f55c",
  null
  
)

export default component.exports